module.exports = __webpack_public_path__ + "static/media/smileRating4Active.382514ed.svg";